<div mat-dialog-content style="text-align: center;">
  <p [innerHTML]="data.message"></p>
  <p [innerHTML]="data.name"></p>
 </div>
 <div mat-dialog-actions align="center">

  <button class="mat-button"(click)="onNoClick()">Nej</button>
  <button class="mat-raised-button mat-primary" [mat-dialog-close]="data.payload" cdkFocusInitial>Ja</button>
 </div>